import { useContext } from 'react';

import { SupportTicketStoreContext } from './store-context';

export const useSupportTicketStore = () => useContext(SupportTicketStoreContext);
